/* @noflow FIXME */
import * as React from 'react';

import User from 'entities/User';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import PhoneCallButton from 'phoneCalls/components/PhoneCallButton';
import Time from 'components/Time';
import IndividualChatStarter from 'components/IndividualChatStarter';
import UserAvatar from 'users/components/UserAvatar';

import type { DenialReason } from 'phoneCalls/components/PhoneCallModal';

const STATUS_TO_HUMAN_STATUS = {
  in_progress: 'Call in progress',
  outgoing: 'Outgoing call',
  incoming: 'Incoming call',
  missed: 'Missed call',
  failed: 'Outgoing call',
  canceled: 'Outgoing call',
  unknown: 'Call status unknown',
};

type CallUser = {
  uuid: string,
  id: Backbone$Id,
  name: string,
  initials: string,
  color: string,
  contactability_status: ContactabilityStatus,
  chat_eligibility_state: string,
  canPhoneDenialReason: DenialReason,
  canPhone: boolean,
  profilePictureUrl: ?string,
};

export type PhoneCall = {
  uuid: string,
  otherUser: CallUser,
  started_at: string,
  status_localization_key: string,
};

type Props = {
  phoneCall: PhoneCall,
};

function PhoneCallsLogTableRow(props: Props) {
  const { phoneCall } = props;
  const { otherUser } = phoneCall;
  const canChat = otherUser.chat_eligibility_state === 'eligible';
  const color = phoneCall.status_localization_key === 'missed' ? 'lava' : 'midnight';

  return (
    <tr key={phoneCall.uuid}>
      <td>
        <IndividualChatStarter
          user={User.fromJSON(otherUser)}
          data-test="chat-starter"
          disabled={!canChat}
          color="pitch">
          <MediaObject center>
            <UserAvatar size="medium" user={otherUser} />
            <Text color={color} truncate>
              {otherUser.name}
            </Text>
          </MediaObject>
        </IndividualChatStarter>
      </td>
      <td>
        <Text color={color}>
          <Time
            date={new Date(phoneCall.started_at)}
            month="short"
            day="numeric"
            year="numeric"
            hour="numeric"
            minute="numeric"
          />
        </Text>
      </td>
      <td>
        <Text color={color}>{STATUS_TO_HUMAN_STATUS[phoneCall.status_localization_key]}</Text>
      </td>
      <td>
        <PhoneCallButton
          inline
          calleeUuid={otherUser.uuid}
          calleeName={otherUser.name}
          denialReason={otherUser.canPhoneDenialReason}
        />
      </td>
    </tr>
  );
}

export default PhoneCallsLogTableRow;
